import { useEffect, type ReactNode } from "react";
import posthog from "posthog-js";

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
    if (!key) return;

    posthog.init(key, {
      api_host: "https://us.i.posthog.com",
      capture_pageview: true,
      persistence: "localStorage+cookie",
    });
  }, []);

  return <>{children}</>;
}

